import React__default from 'react';
import styled, { css, keyframes } from 'styled-components';
import { I as Icon } from '../Icon/Icon-CoM8rI0H.js';
import { d as sparkleSolid } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const SparkleGroup = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-1h26fln-0"
})(["position:relative;padding:0.8em;display:inline-flex;align-items:center;justify-content:center;"]);
const sparkleColorAnimation = theme => keyframes(["0%{color:", ";}50%{color:", ";}100%{color:", ";}"], theme.color.blue[600], theme.color.lightBlue[500], theme.color.blue[600]);
const sparkleSpinAnimation = /*#__PURE__*/keyframes(["0%{transform:rotate(-270deg) translateX(0.4em) rotate(270deg) scale(1);}50%{transform:rotate(-450deg) translateX(0.5em) rotate(450deg) scale(0.15);}100%{transform:rotate(-630deg) translateX(0.4em) rotate(630deg) scale(1);}"]);
const spinAnimation = /*#__PURE__*/css(["animation-name:", ";"], sparkleSpinAnimation);
const aiAnimation = /*#__PURE__*/css(["animation-name:", ",", ";"], sparkleSpinAnimation, ({
  theme
}) => sparkleColorAnimation(theme));
const AIGenIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40026394__sc-1h26fln-1"
})(["position:absolute;", " animation-duration:1800ms;animation-timing-function:linear;animation-iteration-count:infinite;"], ({
  color
}) => color === 'ai' ? aiAnimation : spinAnimation);
const Sparkle1 = /*#__PURE__*/styled(AIGenIcon).withConfig({
  componentId: "sc-storm-ui-40026394__sc-1h26fln-2"
})([""]);
const Sparkle2 = /*#__PURE__*/styled(AIGenIcon).withConfig({
  componentId: "sc-storm-ui-40026394__sc-1h26fln-3"
})(["animation-delay:-0.6s;"]);
const Sparkle3 = /*#__PURE__*/styled(AIGenIcon).withConfig({
  componentId: "sc-storm-ui-40026394__sc-1h26fln-4"
})(["animation-delay:-1.2s;"]);
const AISparkleIcon = ({
  loading,
  color
}) => loading ? /*#__PURE__*/React__default.createElement(SparkleGroup, {
  "data-testid": "storm-ui-icon-sparkle-group"
}, /*#__PURE__*/React__default.createElement(Sparkle1, {
  type: sparkleSolid,
  color: color
}), /*#__PURE__*/React__default.createElement(Sparkle2, {
  type: sparkleSolid,
  color: color
}), /*#__PURE__*/React__default.createElement(Sparkle3, {
  type: sparkleSolid,
  color: color
})) : /*#__PURE__*/React__default.createElement("div", {
  style: {
    width: '1.6em'
  }
}, /*#__PURE__*/React__default.createElement(Icon, {
  type: sparkleSolid
}));

export { AISparkleIcon as A };
//# sourceMappingURL=AISparkleIcon-I_kID0yt.js.map
